import { access } from 'fs';
import APIService from '../../services/APIService';

import type { AudioHealthSummary } from './RecordingSession';

export const startTranscriptionSession = async (
  recordingSessionId: string,
  accessToken?: string | null,
  recordingPipeline?: string,
  onNetworkDelay?: () => void,
  onNetworkAbsoluteTimeout?: () => void,
): Promise<string | null> => {
  const transcriptionSessionResponse = await APIService.makeAPIPostRequest({
    requestString: '/transcriptionSession/startTranscriptionSession',
    accessToken,
    body: {
      recording_session_id: recordingSessionId,
      recording_pipeline: recordingPipeline,
    },
    onNetworkDelay: onNetworkDelay,
    onNetworkAbsoluteTimeout: onNetworkAbsoluteTimeout,
  });
  if (transcriptionSessionResponse.ok) {
    console.log(
      `Started TranscriptionSession: ${transcriptionSessionResponse.value.transcription_session_id}`,
    );
    return transcriptionSessionResponse.value.transcription_session_id;
  } else {
    // SentryService.captureMessage(
    //   "Failed to start TranscriptionSession.",
    //   "error"
    // );
    console.error('Failed to start TranscriptionSession.');
    return null;
  }
};

export const endTranscriptionSession = async (
  transcriptionSessionId: string,
  recordingSessionLogs: string,
  accessToken?: string | null,
  audioHealthSummary?: AudioHealthSummary,
): Promise<boolean> => {
  const transcriptionSessionResponse = await APIService.makeAPIPostRequest({
    requestString: '/transcriptionSession/endTranscriptionSession',
    accessToken,
    body: {
      transcription_session_id: transcriptionSessionId,
      recording_session_logs: recordingSessionLogs,
      // GDN-2205: structured summary so the BE can persist/forward it without
      // parsing the logs string. Omitted when no session data is available.
      ...(audioHealthSummary ? { audio_health_summary: audioHealthSummary } : {}),
    },
  });
  if (transcriptionSessionResponse.ok) {
    console.log('Recording ended.');
    return true;
  } else {
    console.error('Failed to end transcription session.');
    return false;
  }
};
